import { useState } from 'react'

/**
 * useEntityMode - Entity-specific state management for EntityDetailMap
 * 
 * Manages state that's unique to entity detail view:
 * - Entity gallery (images)
 * - Sighting confirmations
 * - Gallery render control
 * 
 * Only used by EntityDetailMap, not HomePageMap.
 * 
 * @returns {Object} Entity mode state and setters
 * 
 * @idempotent - Manages isolated entity-specific state
 * @atomic - Single purpose: entity detail functionality
 */
export function useEntityMode() {
  // Entity gallery state
  const [entityGallery, setEntityGallery] = useState([])
  const [galleryRenderKey, setGalleryRenderKey] = useState(0)
  
  // Confirmation state
  const [confirmingSighting, setConfirmingSighting] = useState(null) // Sighting being confirmed with modal
  
  // Helper to force gallery re-render
  const refreshGallery = () => {
    setGalleryRenderKey(prev => prev + 1)
  }
  
  return {
    // Gallery state
    entityGallery,
    setEntityGallery,
    galleryRenderKey,
    setGalleryRenderKey,
    refreshGallery,
    
    // Confirmation state
    confirmingSighting,
    setConfirmingSighting
  }
}
